import { render } from "./PlaceHolderCard.vue?vue&type=template&id=2d2dde76&scoped=true"
import script from "./PlaceHolderCard.vue?vue&type=script&lang=js"
export * from "./PlaceHolderCard.vue?vue&type=script&lang=js"

import "./PlaceHolderCard.vue?vue&type=style&index=0&id=2d2dde76&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dxworks\\Downloads\\dpp_adm_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2dde76"]])

export default __exports__